import { Component } from '@angular/core';

@Component({
	selector: 'app-dialog-spinner',
	templateUrl: './dialog-spinner.component.html',
	styleUrls: ['./dialog-spinner.component.scss']
})
export class DialogSpinnerComponent {
	requests: string[] = [];
}
